import { render, staticRenderFns } from "./app-msg.vue?vue&type=template&id=aba36924"
import script from "./app-msg.vue?vue&type=script&lang=js"
export * from "./app-msg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports